<script setup lang="ts">
  const { status } = useAuth();
  const accountStore = useAccountStore();

  // Fetch CSRF token on mount — it's embedded as a hidden form input.
  // The form itself is a native POST submission, so the browser follows all
  // 302 redirects (including the one to Zitadel) as page navigations, 
  // completely bypassing CORS restrictions.
  const csrfToken = ref('');
  onMounted(async () => {
    const data = await $fetch<{ csrfToken: string }>('/api/auth/csrf');
    csrfToken.value = data.csrfToken;
  });

  watchEffect(async () => {
    if (status.value === 'authenticated') {
      await accountStore.init();
      navigateTo('/dashboard', { replace: true });
    }
  });

  definePageMeta({ layout: 'auth' });
</script>
<template>
  <div class="flex flex-col items-center justify-center">
    <div class="w-full max-w-md p-8 space-y-6 bg-white dark:bg-gray-900 rounded-lg shadow-xl border border-gray-100 dark:border-gray-800">
      <div class="text-center space-y-2">
        <h1 class="text-3xl font-bold tracking-tight">Welcome Back</h1>
        <p class="text-sm text-gray-500 dark:text-gray-400">Sign in to access your account</p>
      </div>
      <!-- Native form POST: browser follows all OAuth redirects as page navigations, bypassing CORS -->
      <form method="post" action="/api/auth/signin/zitadel">
        <input type="hidden" name="csrfToken" :value="csrfToken" />
        <input type="hidden" name="callbackUrl" value="/dashboard" />
        <UButton
          type="submit"
          :disabled="!csrfToken"
          size="lg"
          color="primary"
          class="w-full flex items-center justify-center font-medium tracking-wide">
          Sign in with Zitadel
        </UButton>
      </form>
    </div>
  </div>
</template>
